<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a>
<figure class="full ">
<img alt=" " id="fig_TheGraceOfEverydaySaints-2" src="images/TheGraceOfEverydaySaints-2.jpg"/>
</figure>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?37e86010